import { createTheme } from "@mui/material/styles";

export const typographyTheme = {
    htmlFontSize: 16,
    fontSize: 16,
    h1: {
        fontSize: "1.6rem",
        fontWeight: 600,
    },
    h2: {
        fontSize: "1.4rem",
        fontWeight: 600,
        lineHeight: 1.6,
    },
    h3: {
        fontSize: "1.1rem",
        fontWeight: 600,
        lineHeight: 1.6,
    },
    h4: {
        fontSize: "1rem",
        fontWeight: 600,
        lineHeight: 1.6,
    },
    h5: {
        fontSize: "1rem",
        fontWeight: 400,
    },
    h6: {
        fontSize: "1rem",
        "@media (min-width:600px)": {
            fontSize: "1.5rem",
        },
    },
    subtitle1: {
        fontSize: ".9rem",
        fontWeight: 400,
        lineHeight: 1.75,
        letterSpacing: "0.04em",
    },
    subtitle2: {
        fontSize: ".9rem",
        fontWeight: 400,
        lineHeight: 1.75,
        letterSpacing: "0.04em",
        fontStyle: "italic",
    },
    body1: {
        fontSize: "1rem",
    },
    body2: {
        fontSize: ".9rem",
        lineHeight: 1.75,
    },
};
const X360Theme = createTheme({
    palette: {
        primary: {
            light: "rgb(154, 224, 194)",
            main: "rgb(112, 210, 168)",
            dark: "rgb(53, 178, 124)",
            contrastText: "#FFFFFF",
        },
        secondary: {
            main: "#01345F",
            contrastText: "#FFFFFF",
        },
        error: {
            light: "#FECBD3",
            main: "#B31527",
            dark: "#6C000C",
            contrastText: "#FFFFFF",
        },
        warning: {
            main: "#ff9800",
        },
        info: {
            main: "#2196F3",
        },
        success: {
            main: "#4CAF50",
            contrastText: "#FFFFFF",
        },
        grey: {
            200: "rgba(158,158,158,0.20)",
            500: "rgba(158,158,158,0.50)",
            700: "rgba(158,158,158,0.70)",
        },
        white: {
            100: "rgba(255,255,255,100)",
        },
        neutral: {
            main: "rgba(243,243,243,1)",
            dark: "rgba(230,230,230,1)",
            contrastText: "rgba(0,0,0,0.7)",
        },
        gold: {
            main: "#FFD700",
        },
        text: {
            primary: "rgba(0,0,0,0.7)",
            secondary: "rgba(0,0,0,0.6)",
            disabled: "rgba(0,0,0,0.38)",
        },
        background: {
            paper: "rgb(255,255,255)",
            default: "rgb(245,245,245)",
        },
    },
    typography: typographyTheme,
});

export default X360Theme;
